import { FC, useEffect, useRef, useState } from "react";
import "../../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouseFloodWater } from "@fortawesome/free-solid-svg-icons";
import { LocationMarkerPopup } from "../../mainLayer/MainWindow";
import { getGlobalLayer } from "../MainWindow";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import { allFloodMap } from "./FloodLayer";
import { floodMapGlofas } from "./FloodLayer";
import { ecmf } from "./FloodLayer";
import addFloodLayerGroup from "./FloodLayer";
import { ThemeProvider, useTheme } from "../../theme/ThemeContext";
import { useMapLayersContext } from "../../provider/MapLayers";

let isButtonClicked: boolean = false;
let floodMap: Map<number, ImageLayer<ImageWMS>> = new Map();

interface FloodProps {
  senddValueFromFlood: (value: string) => void;
  timeIndexCountFlood: number | undefined;
  weatherlayerState: string;
  setTimeLayer: (layer: string) => void;
}

const Flood: React.FC<FloodProps> = ({
  senddValueFromFlood,
  timeIndexCountFlood,
  weatherlayerState,
  setTimeLayer
}) => {
  const { loadLayerInMap, selectLayerInMap } = useMapLayersContext();
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [timeLineCounter, setTimeLineCounter] = useState<number>();
  const [hoveredFlood, setHoveredFlood] = useState(false);
  const { theme } = useTheme();
  const [layerSideButtonClicked, setLayerSideButtonClicked] = useState<boolean>(false);
  const hasExecutedFloodIcon = useRef(false);
    
    useEffect(() => {
      const timer = setTimeout(() => {
      if (loadLayerInMap !== "flood") {
        hasExecutedFloodIcon.current = false;
      }

      if (loadLayerInMap === "flood" && !hasExecutedFloodIcon.current) {
        isButtonClicked = false;
        setIsClicked((prevState) => !prevState);
        if (isClicked === true) {
          selectLayerInMap("floodnot"); 
          LocationMarkerPopup("floodnot");
        } else if (isClicked === false) {
          senddValueFromFlood("Flood");
          setTimeLayer("flood");
          LocationMarkerPopup("flood");
        }

        
        if (!layerSideButtonClicked) {
          const timer = setTimeout(() => {
            floodIconClick();
            setLayerSideButtonClicked(true);
            hasExecutedFloodIcon.current = true;
          }, 500);
          return () => clearTimeout(timer);
        }
      }
    }, 500);

    return () => clearTimeout(timer);
    }, [loadLayerInMap]);

    useEffect(() => {}, [layerSideButtonClicked]);

  useEffect(() => {
    if (timeIndexCountFlood! < 504) {
      isButtonClicked = true;
      if (timeIndexCountFlood! <= 144) {
        if (timeIndexCountFlood! % 3 === 0) {
          setTimeLineCounter(timeIndexCountFlood);
        }
      } else {
        if (timeIndexCountFlood! % 6 === 0) {
          console.log(`Received Count(6): ${timeIndexCountFlood}`);
          setTimeLineCounter(timeIndexCountFlood);
        }
      }
      if ((timeLineCounter ?? 0) > 0 && weatherlayerState === "flood") {
        floodIconClick();
      }
    }
  }, [timeIndexCountFlood]);

  useEffect(() => { }, [isButtonClicked]);

  useEffect(() => {
    if (weatherlayerState === "windnot" || weatherlayerState === "temperaturenot" || weatherlayerState === "rainnot" || weatherlayerState === "airPressurenot" || weatherlayerState === "satellite not") {
      isButtonClicked = true;
      setIsClicked(false);
      if (isClicked) {
        LocationMarkerPopup("flood");
      }
    }
  }, [weatherlayerState]);

  useEffect(() => {
    if (isClicked) {
      senddValueFromFlood("Flood");
    } else {
      senddValueFromFlood("");
    }
  }, [isClicked]);

  useEffect(() => {
    try {
      for (let i = 0; i <= ecmf.size; i++) {
        const value = ecmf.get(i);
        var layers = new ImageLayer({
          source: new ImageWMS({
            url: "https://wms.tecxal.com/visura/weatherwmseagle",
            params: {
              LAYERS: `weather:2024-09-16dsuvspeed_1000hpa_${value}`,
              STYLES: "weather:wind",
            },
            serverType: "geoserver",
            projection: "EPSG:4326",
          }),
        });

        floodMap.set(i, layers);
        allFloodMap("flood", floodMap);
      }
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  }, []);

  const floodIconClick = async () => {
    try {
      const windLayerMap = floodMapGlofas.get("flood");
      const timeLine = timeLineCounter === undefined ? 0 : timeLineCounter;

      if (windLayerMap) {
        const layer = windLayerMap.get(timeLine);

        if (layer) {
          console.log(`Layer for counter ${timeLineCounter}:`, layer);
          getGlobalLayer(layer);
          //  map.addLayer(layers);
          if (!isButtonClicked) {
            addFloodLayerGroup(layer, isClicked, "flood");
          } else {
            addFloodLayerGroup(layer, false, "flood");
          }
        }
      }
      // setWeatherLayer("flood");
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };


  return (
    <>
      <div className="leftsidemenulist-btn-cover"
        onClick={() => {
          isButtonClicked = false;
          setIsClicked((prevState) => !prevState);
          if (isClicked === true) {
            selectLayerInMap("floodnot"); 
            LocationMarkerPopup("floodnot");
          } else if (isClicked === false) {
            senddValueFromFlood("flood");
            setTimeLayer("flood");
            LocationMarkerPopup("flood");
          }
          floodIconClick();
        //  LocationMarkerPopup("flood");
        }}
        onTouchStart={() => {
          isButtonClicked = false;
          setIsClicked((prevState) => !prevState);
          if (isClicked === true) {
            selectLayerInMap("floodnot"); 
            LocationMarkerPopup("floodnot");

          } else if (isClicked === false) {
            senddValueFromFlood("flood");
            setTimeLayer("flood");
            LocationMarkerPopup("flood");

          }
          floodIconClick();
        //  LocationMarkerPopup("flood");
        }}
      >
        <div
          onMouseEnter={() => setHoveredFlood(true)}
          onMouseLeave={() => setHoveredFlood(false)}
          className="leftsidemenulist-btns"
          style={
            {
              /* border: "1px solid red"  */
            }
          }
        >
          <FontAwesomeIcon size="1x" icon={faHouseFloodWater} className="leftside-icon" />
        </div>
        {theme === "light" && (
          <div
            className={isClicked
              ? "leftsidemenulist-btn-tooltip-clicked-light" : hoveredFlood ? "leftsidemenulist-btn-tooltip-hover-light" : "leftsidemenulist-btn-tooltip-light"}
            onMouseEnter={() => setHoveredFlood(true)}
            onMouseLeave={() => setHoveredFlood(false)}
          >
            Flood
          </div>
        )}
        {theme !== "light" && (
          <div
            className={isClicked
              ? "leftsidemenulist-btn-tooltip-clicked" : hoveredFlood ? "leftsidemenulist-btn-tooltip-hover" : "leftsidemenulist-btn-tooltip"}
            onMouseEnter={() => setHoveredFlood(true)}
            onMouseLeave={() => setHoveredFlood(false)}
          >
            Flood
          </div>
        )}
      </div>
    </>
  );
};

export default Flood;
